import { FormProps } from 'antd';
import { ColumnType } from 'antd/lib/table';

type CellEvent<T> = Pick<ColumnType<T>, 'onCell'>['onCell'];

export const stopPropagationOnCell: CellEvent<unknown> = () => ({ onClick: (ev) => ev.stopPropagation() });

export const scrollToFirstErrorProps: FormProps['scrollToFirstError'] = { behavior: 'smooth', block: 'center' };
